import { render, staticRenderFns } from "./SchemaComponent.vue?vue&type=template&id=65ff52d2&scoped=true"
import script from "./SchemaComponent.vue?vue&type=script&lang=js"
export * from "./SchemaComponent.vue?vue&type=script&lang=js"
import style0 from "./SchemaComponent.vue?vue&type=style&index=0&id=65ff52d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ff52d2",
  null
  
)

export default component.exports